import { render, staticRenderFns } from "./BulkSetOwnerModal.vue?vue&type=template&id=745bebd0"
import script from "./BulkSetOwnerModal.vue?vue&type=script&lang=js"
export * from "./BulkSetOwnerModal.vue?vue&type=script&lang=js"
import style0 from "./BulkSetOwnerModal.vue?vue&type=style&index=0&id=745bebd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports